import { UsersProvider } from "../../contexts/UserContext";
import UserAssignmentGrid from "./components/UserAssignmentGrid";
import UserAssignmentToolbar from "./components/UserAssignmentToolbar";
import { UserAssignmentsProvider } from "./context/UserAssignmentContext";

export default function UserAssignmentTab() {
    return (
        <UsersProvider>
            <UserAssignmentsProvider>
                <UserAssignmentToolbar />
                <UserAssignmentGrid />
            </UserAssignmentsProvider>
        </UsersProvider>
    );
}
